import { Component, OnInit, OnChanges, ViewChild } from "@angular/core";
import { DatePipe } from "@angular/common";
import { TimesheetApprovalsService } from "./timesheet-approvals.service";
import { ApproveDetail, ApproveAll, ApprovalList } from "./timesheet-approvals";
import { MatSnackBar } from "@angular/material";
import { Router, ActivatedRoute } from "@angular/router";
import { DateDisplay } from "../../employee/timesheet-entry/timesheet.interface";
import { SessionStorage } from "ngx-webstorage";
import { PopoverModule } from "ngx-popover";

@Component({
  selector: "app-timesheet-approvals",
  templateUrl: "./timesheet-approvals.component.html",
  styleUrls: ["./timesheet-approvals.component.css"],
})
export class TimesheetApprovalsComponent implements OnInit {
  @SessionStorage() public user;
  @SessionStorage() public config;

  public firstDay: any;
  public lastDay: any;
  public firstDayDate: any;
  public lastDayDate: any;
  public yearFirst: any;
  public yearLast: any;
  public weekNumer: any;
  public currentDate: any;
  public currentWeek: string;
  public currentYear: any;
  public currentDateDay: string;
  public iscurrentDay: any;
  public timesheetlistshow: boolean;
  public dateDisplay: Array<any> = [];
  public data: any;
  public rmtimesheetapprovals: ApprovalList[] = [];
  public selectedrowdetails: any;
  constructor(
    public router: Router,
    public activeroute: ActivatedRoute,
    public datePipe: DatePipe,
    public timesheetApprovalService: TimesheetApprovalsService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const currentDAY = new Date();
    this.currentDate = new Date().getDate();
    this.currentDateDay = this.currentDate + " " + days[new Date().getDay()];
    this.currentYear = new Date().getFullYear();
    this.getWeekDays(currentDAY);
    this.currentWeek = this.datePipe.transform(currentDAY, "ww");
    this.getrmTimesheetApprovals();
    this.timesheetlistshow = true;
  }

  getWeekDays(currentDate) {
    this.dateDisplay = [];
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const curr = new Date(currentDate);
    let first;
    if (this.config.businessUnit === "accenture") {
      first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    } else {
      first = curr.getDate() - curr.getDay() + 1; // First day is the day of the month - the day of the week
    }
    this.firstDay = new Date(curr.setDate(first)).toUTCString();
    const startDate = new Date(this.firstDay);
    this.lastDay = new Date(startDate.setDate(startDate.getDate() + 6));
    this.firstDayDate =
      new Date(this.firstDay).getDate() +
      " " +
      monthNames[new Date(this.firstDay).getMonth()];
    this.lastDayDate =
      new Date(this.lastDay).getDate() +
      " " +
      monthNames[new Date(this.lastDay).getMonth()];
    this.yearFirst = new Date(this.firstDay).getFullYear();

    this.yearLast = new Date(this.lastDay).getFullYear();
    if (this.yearFirst == this.yearLast) {
      this.currentYear = this.yearLast;
    } else {
      this.currentYear = this.yearLast - 1;
    }

    this.weekNumer = this.datePipe.transform(startDate, "ww");
    if (this.config.businessUnit !== "accenture") {
      this.weekNumer = (this.weekNumer - 1).toString();
    }
    /*Get all the 7 days date in the current week with respective flags */
    for (let i = 0; i < 7; i++) {
      this.getDateDay(i);
    }
    const today = new Date();
    this.iscurrentDay = today.getDate();
    this.currentWeek = this.datePipe.transform(currentDate, "ww");
  }

  getDateDay(number) {
    const getDate = new DateDisplay();
    let days;
    if (this.config.businessUnit === "accenture") {
      days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    } else {
      days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    }
    getDate.day = days[number];
    const date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() + number);
    if (date.getTime() > new Date().getTime()) {
      getDate.flag = false;
    }
    getDate.date = date.getDate();
    this.dateDisplay.push(getDate);
  }

  getPreviousWeek() {
    const date = new Date(this.firstDay);
    date.setDate(new Date(this.firstDay).getDate() - 3);
    this.getWeekDays(date);
    this.getrmTimesheetApprovals();
  }
  getNextWeek() {
    const date = new Date(this.lastDay);
    date.setDate(new Date(this.lastDay).getDate() + 1);
    this.getWeekDays(date);
    this.getrmTimesheetApprovals();
  }

  /**function to get rm timesheet approval*/
  getrmTimesheetApprovals() {
    this.rmtimesheetapprovals = [];
    this.timesheetApprovalService
      .getrmTimesheetApprovals((new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
      this.datePipe.transform(this.firstDay, "ww") == "53")?1:this.currentWeek,
                 (new Date(this.firstDay).getFullYear() != new Date(this.lastDay).getFullYear() &&
      this.datePipe.transform(this.firstDay, "ww") == "53")
         ? this.currentYear + 1
         : this.currentYear)
      .subscribe((data) => {
        data.payload.data.forEach((value) => {
          let count = 0;
          const model = new ApprovalList(value, this.config.businessUnit);
          if (model.timesheetDetails.length > 0) {
            for (let i = 0; i < model.timesheetDetails.length; i++) {
              for (let d = 0; d < 7; d++) {
                if (
                  model.timesheetDetails[i].dayparam == this.dateDisplay[d].date
                ) {
                  model.days[d] = model.timesheetDetails[i].totalhrsspents;
                  if (
                    model.dateDetails[i].leaveType == undefined ||
                    model.dateDetails[i].leaveType == ""
                  ) {
                    model.dayLeave[d] = null;
                  } else {
                    model.dayLeave[d] = model.dateDetails[i].leaveType;
                  }
                  model.dayPopUp[d] = model.timesheetDetails[i].activityDetails;
                  if (
                    this.config.businessUnit === "ipdo" ||
                    this.config.businessUnit === "biologics" ||
                    this.config.businessUnit === "chinateam" ||
                    this.config.businessUnit === "aps"
                  ) {
                    model.dayPopUp[d].forEach((element) => {
                      const time = this.convertHoursToMins(element.filledhrs);
                      element.filledhrs = this.convertMinsToHrsMins(time);
                    });
                  }
                }
              }

              if (model.timesheetDetails[i].approvalStatus == "0") {
                model.buttonText = "Approve";
                model.buttondisabled = false;
                count++;
              } else if (model.timesheetDetails[i].approvalStatus == "2") {
                model.buttonText = "Approved";
                model.buttondisabled = true;
              }
              if (count > 0) {
                model.buttonText = "Approve";
                model.buttondisabled = false;
              }
            }
            this.rmtimesheetapprovals.push(model);
          }
        });
      });
  }

  /**function to convert hours to mins*/
  convertHoursToMins(hrs) {
    const a = hrs.toString().split(":");
    let minutes = 0;
    if (a[1]) {
      minutes = +a[0] * 60 + +a[1];
    } else {
      minutes = +Number(a[0]) * 60;
    }
    return minutes;
  }

  /**function to convert mins ro hours*/
  convertMinsToHrsMins(mins) {
    const h: any = Math.floor(mins / 60);
    let m: any = mins % 60;
    m = Math.round(m);
    const hrs = h < 10 ? "0" + h : h;
    const mns = m < 10 ? "0" + m : m;
    return `${hrs}:${mns}`;
  }

  /**function to approve employee timesheet*/
  approveButtonClicked(rowDetail, index) {
    this.rmtimesheetapprovals[index].buttonText = "Approved";
    this.rmtimesheetapprovals[index].buttondisabled = true;
    this.timesheetApprovalService
      .rmTimesheetApprove(this.currentWeek, rowDetail, this.currentYear)
      .subscribe(
        (data) => {
          this.snackBar.open("Timesheet approved successfully", "OK", {
            duration: 5000,
          });
          this.getrmTimesheetApprovals();
        },
        (error) => {
          this.snackBar.open("Error in timesheet approval", "OK", {
            duration: 5000,
          });
        }
      );
  }

  /**function to approve all timesheet*/
  approveAllClicked(timesheetData) {
    const data = new ApproveAll({});
    timesheetData.forEach((element, i) => {
      const approveData = new ApproveDetail();
      approveData.datetoApprove = [];
      if (!element.buttondisabled) {
        element.dateDetails.forEach((ele) => {
          const obj = Object.assign({}, ele);
          if (obj.approvalStatus.status != 2) {
            delete obj.approvalStatus;
            delete obj.createdDate;
            delete obj.leaveType;
            delete obj.__v;
            delete obj._id;
            approveData.datetoApprove.push(obj);
            approveData.empno = element.employeenumber;
          }
        });
        data.timeSheetDetail.push(approveData);
      }
      data.rmcode = this.user.Empno;
      data.weeknumber = Number(this.currentWeek);
    });
    if (data.timeSheetDetail.length >= 1) {
      this.timesheetApprovalService
        .rmTimesheetApproveAll(data)
        .subscribe((res) => {
          this.snackBar.open("Timesheets approved successfully", "OK", {
            duration: 5000,
          });
          this.getrmTimesheetApprovals();
        });
    } else {
      this.snackBar.open("No Timesheet pending for approval", "OK", {
        duration: 5000,
      });
    }
  }

  /**function to view detailed timesheet after clicked*/
  timesheetrowClicked(row) {
    if (!row.buttondisabled) {
      this.timesheetApprovalService.setSelectedRowData(
        row,
        this.weekNumer,
        this.currentYear
      );
      this.timesheetlistshow = false;
      this.router.navigate(["rm/viewtimesheetDetails"]);
    }
  }

  /**function to view timesheet detailed view on hover*/
  openPopUp(index, day, j) {
    if (this.rmtimesheetapprovals[index].dayPopUp[j]) {
      this.rmtimesheetapprovals[index].showDaypopUpFlag[j] =
        !this.rmtimesheetapprovals[index].showDaypopUpFlag[j];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/rm/timesheet-approvals/timesheet-approvals.component.ts